import { Avatar } from "antd";
import styled from "styled-components";

const StyledAvatar = styled(Avatar)`
  ${(props) => props.$backgroundColor && `background-color: ${props.$backgroundColor};`}
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
  flex-shrink: 0;
  font-weight: 600;
`;

const AVATAR_COLORS = [
  "#795548", // medium brown
  "#5d4037", // dark brown
  "#8d6e63", // taupe
  "#6d4c41", // cocoa
  "#546e7a", // steel
  "#455a64", // dark steel
  "#7e6b54", // bronze
  "#607d8b", // slate
  "#558b2f", // olive green
  "#33691e", // forest
  "#827717", // dark olive
  "#5d4e75", // muted plum
  "#7e4f5f", // muted wine
  "#4f6855", // sage
  "#614a3f", // coffee
  "#616161", // gray
];

function hashColor(seed) {
  if (!seed) return AVATAR_COLORS[0];
  const str = String(seed);
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) % 2147483647;
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export function getInitials(name) {
  if (!name) return "?";
  const cleaned = String(name).trim();
  if (!cleaned) return "?";
  const parts = cleaned.split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return parts[0][0].toUpperCase();
}

export default function UserBadge({ name, image, userId, size = 36, onClick, className }) {
  return (
    <StyledAvatar
      shape="square"
      size={size}
      src={image || undefined}
      onClick={onClick}
      className={className}
      $backgroundColor={image ? undefined : hashColor(userId ?? name)}
      $clickable={!!onClick}
    >
      {!image && getInitials(name)}
    </StyledAvatar>
  );
}
